import { useEffect, useState } from 'react'
export const usePromiseAsString = (
  fn?: () => Promise<string>,
  onError?: (error: Error) => void,
): string | null => {
  const [value, setValue] = useState<string | null>(null)
  useEffect(() => {
    // If the function is not defined, don't do anything
    if (!fn) return
    // If the value is already set, don't do anything
    if (value) return
    fn()
      .then(setValue)
      .catch(e => onError && onError(e))
  }, [fn, onError, value])
  return value
}
